import React from "react";
import { Link } from "react-router-dom";
import logo from "./assets/Xmaths.png";
import { GiTeacher } from "react-icons/gi";
import CircularText from './CircularText';


const Navbar = () => {
  return (
    <nav className="bg-white/10 backdrop-blur-md border-b border-white/20 text-black sticky top-0 z-50 shadow-lg">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <div class="scale-50 h-28 -mt-8 -mx-8">
              <div className="bg-[url('/Xmaths.png')] bg-center bg-[length:120px] bg-no-repeat filter brightness-0 invert">
                <CircularText
                  text="✦ SHEMIES ✦ MATH ✦ IGCSE "
                  onHover="speedUp"
                  spinDuration={20}
                  className=""
                />
              </div>
            </div>
          </Link>

          {/* Auth Buttons */}
          <div className="flex space-x-4">
            <Link
              to="/login"
              className="px-5 py-2 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 text-black hover:bg-white/30 transition-all duration-300 shadow-lg"
            >
              Login
            </Link>
            <Link
              to="/signup"
              className="px-5 py-2 rounded-full bg-teal-600/80 backdrop-blur-sm border border-teal-500/30 text-white hover:bg-teal-700/80 transition-all duration-300 shadow-lg hover:shadow-teal-500/30"
            >
              Sign Up
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};


export default Navbar;